import React from 'react'
import styled from 'styled-components'
import tw from 'twin.macro'
import { Button } from '../../UI'

const MainContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 2.5rem;
    justify-content: center;
    align-items: center;

    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        margin: 1rem;
        gap: 1rem;
    }
`
const ContentContainer = styled.div`
    margin: 0rem 1rem 0rem 1rem;
`
const Image = styled.img`
    margin: 1rem;
`
const DesktopTitle = styled.h1`
    margin-bottom: 1rem;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: ${(props) => props.theme.color.tellowPurple};
    @media (max-width: 768px) {
        display: none;
    }
`

const MobileTitle = styled.h1`
    display: none;

    @media (max-width: 768px) {
        margin-bottom: 1rem;
        font-size: 1.875rem;
        line-height: 2.25rem;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        font-weight: 600;
        letter-spacing: -0.025em;
        align-items: flex-start;
        color: ${(props) => props.theme.color.tellowPurple};
        display: block;
    }
`
const Text = styled.p`
    margin-bottom: 2rem;
`

const WebinarButton = styled(Button)`
    align-items: center;
    gap: 0.3rem;
    font-size: 0.8rem;
    padding: 18px 28px;
    text-align: center;
    max-width: 24rem;
    @media (max-width: 768px) {
        padding: 10px 38px;
    }
`

const HelpCenterButton = styled(Button)`
    padding: 18px 28px;
    @media (max-width: 768px) {
        padding: 10px 38px;
        text-align: center;
    }
`
const ButtonContainer = styled.div`
    @media (max-width: 768px) {
        display: flex;
        justify-content: center;
    }
`
const style = {
    title: tw`tracking-tight antialiased sm:text-2xl md:text-3xl mb-2`,
    body: tw`antialiased font-normal text-sm text-tellow-gray-800 opacity-80 tracking-tight`,
}

const GettingStarted = ({ data, showWebinatButton }) => (
    <MainContainer>
        <MobileTitle css={style.title}>{data.title}</MobileTitle>
        <Image src={data.img} alt="Getting-started" />
        <ContentContainer>
            <DesktopTitle css={style.title}>{data.title}</DesktopTitle>
            <Text css={style.body}>{data.text}</Text>
            <ButtonContainer>
                {showWebinatButton ? <WebinarButton href={data.url}>{data.textCTA}</WebinarButton> : <HelpCenterButton href={data.url}> {data.textCTA}</HelpCenterButton>}
            </ButtonContainer>
        </ContentContainer>
    </MainContainer>
)
export default GettingStarted
